/**
 * Last check before the cart leaves for checkout.
 *
 * The freebie rule (cart-freebies.js) is already applied on every cart mutation
 * the theme knows about, but a cart changed somewhere else — another tab, a
 * stale drawer, an app — reaches the checkout button unchecked. So the click
 * itself re-reads the cart from the server and applies the rule once more:
 *
 *   paid < ₹499 → free minis and pouch removed
 *   paid < ₹999 → pouch removed
 *   at most 2 free minis in total and 1 pouch — excess trimmed
 *
 * Clean cart → the click is replayed and GoKwik runs as usual. Anything removed
 * → no redirect; the cart is re-rendered and the shopper is told why.
 *
 * Capture phase on document, registered after cart-busy-guard.js, so the busy
 * guard still swallows clicks during a mutation and this runs before GoKwik's
 * inline onclick.
 */
(function () {
  'use strict';

  var CHECKOUT_SELECTOR = [
    '.gokwik-checkout button',
    '.sr-headless-checkout',
    '.cart__checkout-button',
    '[name="checkout"]',
    '#checkout',
    '#CartDrawer-Checkout',
    '.cart__dynamic-checkout-buttons button',
  ].join(',');

  // Owned by ct-atc-flow.js. Dropping the pouch without clearing them reads as
  // "shopper declined it", and it would never be offered again.
  var POUCH_MARKERS = { id: '', gift_declined: '' };

  var checking = false;
  var replaying = false;

  function sectionsOnPage() {
    var sections = [];
    var drawer = document.getElementById('CartDrawer');
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');

    if (drawer) sections.push({ id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' });
    if (items) sections.push({ id: 'main-cart-items', section: items.dataset.id, selector: '.js-contents' });
    if (footer) sections.push({ id: 'main-cart-footer', section: footer.dataset.id, selector: '.js-contents' });
    if (document.getElementById('cart-icon-bubble')) {
      sections.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    }

    return sections;
  }

  function render(sections, state) {
    sections.forEach(function (s) {
      var html = state.sections && state.sections[s.section];
      var el = document.getElementById(s.id);
      if (!html || !el) return;

      var source = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector);
      var dest = el.querySelector(s.selector) || el;
      if (source) dest.innerHTML = source.innerHTML;
    });

    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('is-empty', state.item_count === 0);
  }

  function formatAmount(paise) {
    return '₹' + Math.ceil(paise / 100).toLocaleString('en-IN');
  }

  function messageFor(result) {
    var messages = window.CartFreebies.messages;

    if (result.minisForfeit) {
      return messages.minisRemoved.replace('[amount]', formatAmount(result.miniThreshold - result.paid));
    }
    if (result.pouchForfeit) {
      return messages.pouchRemoved.replace('[amount]', formatAmount(result.pouchThreshold - result.paid));
    }
    return messages.capped;
  }

  function showMessage(text) {
    document.querySelectorAll('.cart-checkout-gate__message').forEach(function (el) {
      el.textContent = text;
      el.hidden = false;
    });
  }

  function correct(result) {
    var sections = sectionsOnPage();
    var body = {
      updates: result.updates,
      sections: sections.map(function (s) { return s.section; }),
      sections_url: window.location.pathname,
    };
    if (result.pouchForfeit) body.attributes = POUCH_MARKERS;

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        render(sections, state);
        showMessage(messageFor(result));
      });
  }

  function replay(control) {
    replaying = true;
    try {
      control.click();
    } finally {
      replaying = false;
    }
  }

  function gate(event) {
    if (replaying || !window.CartFreebies) return;

    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var control = target.closest(CHECKOUT_SELECTOR);
    if (!control) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (checking) return;

    checking = true;
    if (window.CartBusy) window.CartBusy.begin();

    var proceed = false;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var result = window.CartFreebies.checkoutCorrections(cart);
        if (!result.changed) {
          proceed = true;
          return;
        }
        return correct(result);
      })
      // If the cart can't be read, don't hold the sale hostage — let the
      // mutation-time checks stand and go to checkout.
      .catch(function () { proceed = true; })
      .finally(function () {
        checking = false;
        if (window.CartBusy) window.CartBusy.end();
        if (proceed) replay(control);
      });
  }

  document.addEventListener('click', gate, true);
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    gate(event);
  }, true);
})();
